import { Card } from 'react-bootstrap';
import TextLoading from '@/app/common/components/skeleton/TextLoading';

const Block = ({
  width,
  height,
  className = ''
}: {
  width: number | string;
  height: number;
  className?: string;
}) => (
  <span className={`d-block ${className}`.trim()}>
    <TextLoading
      width={width}
      height={height}
      isWidthPx={typeof width === 'number'}
    />
  </span>
);

const CruxMetricPreload = () => (
  <div className="accordion-item mb-2">
    <div className="accordion-header p-3 border rounded">
      <Block width="34%" height={14} />
    </div>
    <div className="accordion-body bg-100 pb-3">
      <div className="row g-3">
        {[1, 2].map(index => (
          <div className="col-12 col-xl-6" key={index}>
            <Card className="h-100 border">
              <Card.Body className="p-3">
                <Block width="46%" height={13} className="mb-4" />
                {index === 1 ? (
                  <>
                    <Block width="72%" height={28} className="mb-3" />
                    <Block width="100%" height={8} className="mb-3" />
                    <Block width="82%" height={10} className="mb-2" />
                    <Block width="68%" height={10} />
                  </>
                ) : (
                  <div className="d-flex align-items-end gap-2" style={{ height: 220 }}>
                    {[80, 115, 95, 145, 125, 165, 110, 150].map(
                      (height, barIndex) => (
                        <Block
                          key={barIndex}
                          width="10%"
                          height={height}
                        />
                      )
                    )}
                  </div>
                )}
              </Card.Body>
            </Card>
          </div>
        ))}
      </div>
    </div>
  </div>
);

const CruxPreload = () => (
  <div className="pb-4" aria-hidden>
    <div className="d-flex align-items-center justify-content-between mb-3 px-1">
      <div>
        <Block width={170} height={18} className="mb-2" />
        <Block width={245} height={10} />
      </div>
    </div>

    <div className="d-flex gap-4 border-bottom pb-2 mb-4">
      <Block width={82} height={12} />
      <Block width={82} height={12} />
    </div>

    <div className="mt-4">
      <div className="d-flex justify-content-between mb-3 px-1">
        <Block width={150} height={16} />
        <Block width={70} height={10} />
      </div>
      {[1, 2, 3].map(index => (
        <CruxMetricPreload key={index} />
      ))}
    </div>
  </div>
);

export default CruxPreload;
